// Only a server-confirmed contact submission with a matching local attempt counts.
const prefix = 'smid-contact-attempt:';
const lifetime = 30 * 60 * 1000;

function initLeadEvents(root = document) {
  root.querySelectorAll('form.sd-native-contact, form.shc-form').forEach((form) => {
    if (form.dataset.leadEventsReady) return;
    form.dataset.leadEventsReady = 'true';
    const key = prefix + form.id;
    form.addEventListener('submit', () => {
      const isTest = new URLSearchParams(location.search).get('smid_test') === '1';
      try { sessionStorage.setItem(key + ':test', isTest ? '1' : '0'); } catch { /* No personal data is stored. */ }
      try { sessionStorage.setItem(key, String(Date.now())); } catch { /* Form still works without storage. */ }
    });
    const success = form.querySelector('[data-smid-lead-success]');
    if (!success) return;
    try {
      if (sessionStorage.getItem(key + ':test') === '1') {
        sessionStorage.removeItem(key);
        sessionStorage.removeItem(key + ':test');
        return;
      }
    } catch { return; }
    let attempt;
    try { attempt = Number(sessionStorage.getItem(key)); } catch { return; }
    if (!attempt || Date.now() - attempt < 0 || Date.now() - attempt > lifetime) return;
    let tries = 0;
    const publish = () => {
      if (!window.Shopify?.analytics?.publish) {
        if (++tries < 20) setTimeout(publish, 500);
        return;
      }
      try {
        const accepted = window.Shopify.analytics.publish('smid_contact_success', {
          form_type: success.dataset.smidLeadSuccess,
          page_path: location.pathname
        });
        if (accepted !== false) {
          sessionStorage.removeItem(key);
          sessionStorage.removeItem(key + ':test');
        }
      } catch { /* Never interfere with the confirmation shown to the customer. */ }
    };
    publish();
  });
}

initLeadEvents();
document.addEventListener('shopify:section:load', (event) => initLeadEvents(event.target));

// Contact clicks are actions, never confirmed leads. Send no address or query data.
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('a[href]');
  if (!link) return;
  let channel;
  try {
    const url = new URL(link.href, location.origin);
    if (url.protocol === 'tel:') channel = 'phone';
    else if (url.protocol === 'mailto:') channel = 'email';
    else if (['wa.me', 'api.whatsapp.com'].includes(url.hostname)) channel = 'whatsapp';
  } catch { return; }
  if (!channel || new URLSearchParams(location.search).get('smid_test') === '1') return;
  try {
    window.Shopify?.analytics?.publish?.('smid_contact_action', {
      channel, page_path: location.pathname
    });
  } catch { /* Navigation must always continue. */ }
});
